import { Select } from "antd";
import { SelectProps } from "antd/lib";
import React from "react";

export const OrientationSelect = (props: SelectProps) => {
  return (
    <Select {...props} defaultValue="ORIENTATION_SYSTEM">
      <Select.Option value="ORIENTATION_SYSTEM">System</Select.Option>
      <Select.Option value="ORIENTATION_PORTRAIT">Portrait</Select.Option>
      <Select.Option value="ORIENTATION_LANDSCAPE">Landscape</Select.Option>
    </Select>
  );
};
